import { graphql } from "react-relay";

export const freemiumStatusCalloutFragments = {
  org: graphql`
    fragment FreemiumStatusCallout_org on Org {
      id

      orgAccountingPeriod {
        __typename
        ... on OrgAccountingPeriod {
          periodRange {
            minDate
            maxDate
          }
          quotaMax
          quotaUsed
          enforcementState
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }

      featureGrid {
        __typename
        ... on FeatureGrid {
          stateMetadata {
            primaryBillingGroupMetadata {
              subscription {
                id
              }
            }
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};
